export const progressInFrames = (seconds: number, fps: number) => Math.round(seconds / (1 / fps));
